import styles from './Footer.module.scss';

import logo from '../../images/logo.svg';
import hhLogo from '../../images/hh.svg';

export const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.logo}>
          <img src={logo} alt="" />
        </div>
        <div className={styles.bottom}>
          <p>© 2024</p>
          <div className={styles.line}></div>
          <img src={hhLogo} alt="" />
          <p>Бренд-центр</p>
        </div>
      </div>
    </div>
  );
};
